import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

interface ReportMatrixFilter {
    from: string;
    to: string;
    projectId?: string;
    customerId?: string;
}

const getReportMatrixData = (
    backend: string,
    token: string,
    filter: ReportMatrixFilter
) => {
    const params = new URLSearchParams({
        from: filter.from,
        to: filter.to,
    });

    if (filter.projectId) {
        params.append('project', filter.projectId);
    }
    if (filter.customerId) {
        params.append('customer', filter.customerId);
    }

    return fetch(
        `${getApiUrl(backend)}report_matrix?${params.toString()}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getReportMatrixData;
